import { classNames } from "helpers/themeHelpers";
import {
  categoryLatestAdsTitleGtm,
  categoryLatestSeeAllAdsGtm,
} from "GTMs/actions/postViewActions";
import {
  ISendLoggingEventProps,
  sendLoggingEvent,
} from "../../../../../../../libs/logging/helpers/sendLoggingEvent";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3,
  EnumGeneratedBy,
  EnumUxTypes,
} from "../../../../../../../libs/logging/types/loggingTypes";
import IconLeftwardsArrow from "assets/icons/IconLeftwardsArrow";
import { useTheme } from "styled-components";
import { FC } from "react";
import { IWidget } from "../../../../types/home";

interface IProps {
  widget: IWidget;
}

const HomeWidgetTitle: FC<IProps> = ({ widget }) => {
  const { isMobile, translations, isDesktop } = useTheme();
  const getLinkSeeMore = () => {
    if (widget?.codename === "all" || widget?.codename === "ContinueBrowsing") {
      return widget?.link?.weblink;
    } else {
      return `${widget?.link?.weblink}/all`;
    }
  };
  const HomeWidgetMainTitle = () => {
    return (
      <a
        href={widget?.link?.weblink}
        className="block blackColor"
        onClick={() =>
          categoryLatestAdsTitleGtm(
            widget.gtm_config?.title?.eventAction,
            widget.gtm_config?.title?.eventLabel,
            {
              Category: widget?.category_reporting_name,
            }
          )
        }
      >
        <h2 {...classNames(isMobile ? "font-18" : "font-26")}>
          {widget?.label}
        </h2>
      </a>
    );
  };

  return (
    <div {...classNames("flex flexSpaceBetween alignItems mb-16")}>
      {widget?.sub_label ? (
        <div {...classNames(isMobile && "trim")}>
          <HomeWidgetMainTitle />
          <div
            {...classNames(
              "darkGrayColor mt-8",
              isMobile ? "font-14 trim" : "font-20"
            )}
          >
            {widget?.sub_label}
          </div>
        </div>
      ) : (
        <HomeWidgetMainTitle />
      )}
      <a
        href={getLinkSeeMore()}
        onClick={() => {
          categoryLatestSeeAllAdsGtm(
            widget?.gtm_config?.see_more?.eventAction,
            widget?.gtm_config?.see_more?.eventLabel,
            {
              Category: widget?.category_reporting_name,
            }
          );
          sendLoggingEvent({
            actionNameLvl1: EnumActionNameLevel1.SEARCH,
            actionNameLvl2: EnumActionNameLevel2.TAXONOMY,
            actionNameLvl3: EnumActionNameLevel3.CLICK,
            currentWidgetName: widget.gtm_config?.title?.widgetName,
            ux_type: EnumUxTypes.LINK,
            generatedBy: EnumGeneratedBy.USER,
          } as ISendLoggingEventProps);
        }}
        {...classNames("inline bold noWrap", isMobile ? "font-14" : "font-24")}
      >
        {translations.more}
        <IconLeftwardsArrow
          height={isMobile ? "14" : "21"}
          width={isMobile ? "14" : "21"}
          className="inline vMiddle ms-8"
        />
      </a>
    </div>
  );
};

export default HomeWidgetTitle;
